// Curated list of major world languages + significant regional dialects so users
// can translate to/from rare combinations (e.g. Mandarin → Shona) for international
// rights & royalty negotiations. Order: most-spoken first, then alphabetical regional.

export const TRANSLATION_LANGUAGES = [
  // Top global languages
  { code: "en", name: "English",            native: "English" },
  { code: "zh", name: "Mandarin Chinese",   native: "中文 (普通话)" },
  { code: "zh-yue", name: "Cantonese",      native: "粵語 (廣東話)" },
  { code: "zh-min-nan", name: "Min Nan / Hokkien", native: "閩南語" },
  { code: "hi", name: "Hindi",              native: "हिन्दी" },
  { code: "es", name: "Spanish",            native: "Español" },
  { code: "es-MX", name: "Spanish (Mexico)", native: "Español (México)" },
  { code: "es-AR", name: "Spanish (Argentina)", native: "Español (Argentina)" },
  { code: "fr", name: "French",             native: "Français" },
  { code: "fr-CA", name: "French (Canada)", native: "Français (Canada)" },
  { code: "ar", name: "Arabic",             native: "العربية" },
  { code: "ar-EG", name: "Arabic (Egyptian)", native: "العربية المصرية" },
  { code: "ar-MA", name: "Arabic (Moroccan)", native: "العربية المغربية" },
  { code: "bn", name: "Bengali",            native: "বাংলা" },
  { code: "pt", name: "Portuguese",         native: "Português" },
  { code: "pt-BR", name: "Portuguese (Brazil)", native: "Português (Brasil)" },
  { code: "ru", name: "Russian",            native: "Русский" },
  { code: "ja", name: "Japanese",           native: "日本語" },
  { code: "ko", name: "Korean",             native: "한국어" },
  { code: "de", name: "German",             native: "Deutsch" },
  { code: "it", name: "Italian",            native: "Italiano" },
  { code: "tr", name: "Turkish",            native: "Türkçe" },
  { code: "vi", name: "Vietnamese",         native: "Tiếng Việt" },
  { code: "fa", name: "Persian / Farsi",    native: "فارسی" },
  { code: "pa", name: "Punjabi",            native: "ਪੰਜਾਬੀ" },
  { code: "ur", name: "Urdu",               native: "اردو" },
  { code: "ta", name: "Tamil",              native: "தமிழ்" },
  { code: "te", name: "Telugu",             native: "తెలుగు" },
  { code: "mr", name: "Marathi",            native: "मराठी" },
  { code: "gu", name: "Gujarati",           native: "ગુજરાતી" },
  { code: "kn", name: "Kannada",            native: "ಕನ್ನಡ" },
  { code: "ml", name: "Malayalam",          native: "മലയാളം" },
  { code: "th", name: "Thai",               native: "ไทย" },
  { code: "id", name: "Indonesian",         native: "Bahasa Indonesia" },
  { code: "ms", name: "Malay",              native: "Bahasa Melayu" },
  { code: "fil", name: "Filipino / Tagalog", native: "Filipino" },
  { code: "pl", name: "Polish",             native: "Polski" },
  { code: "uk", name: "Ukrainian",          native: "Українська" },
  { code: "ro", name: "Romanian",           native: "Română" },
  { code: "nl", name: "Dutch",              native: "Nederlands" },
  { code: "el", name: "Greek",              native: "Ελληνικά" },
  { code: "he", name: "Hebrew",             native: "עברית" },
  { code: "sv", name: "Swedish",            native: "Svenska" },
  { code: "no", name: "Norwegian",          native: "Norsk" },
  { code: "da", name: "Danish",             native: "Dansk" },
  { code: "fi", name: "Finnish",            native: "Suomi" },
  { code: "cs", name: "Czech",              native: "Čeština" },
  { code: "sk", name: "Slovak",             native: "Slovenčina" },
  { code: "hu", name: "Hungarian",          native: "Magyar" },
  { code: "bg", name: "Bulgarian",          native: "Български" },
  { code: "sr", name: "Serbian",            native: "Српски" },
  { code: "hr", name: "Croatian",           native: "Hrvatski" },
  { code: "sl", name: "Slovenian",          native: "Slovenščina" },
  { code: "ca", name: "Catalan",            native: "Català" },
  { code: "is", name: "Icelandic",          native: "Íslenska" },

  // African languages (incl. user-requested Shona)
  { code: "sw", name: "Swahili",            native: "Kiswahili" },
  { code: "am", name: "Amharic",            native: "አማርኛ" },
  { code: "ha", name: "Hausa",              native: "Hausa" },
  { code: "yo", name: "Yoruba",             native: "Yorùbá" },
  { code: "ig", name: "Igbo",               native: "Igbo" },
  { code: "zu", name: "Zulu",               native: "isiZulu" },
  { code: "xh", name: "Xhosa",              native: "isiXhosa" },
  { code: "af", name: "Afrikaans",          native: "Afrikaans" },
  { code: "sn", name: "Shona (Zimbabwe)",   native: "ChiShona" },
  { code: "nd", name: "Ndebele (Zimbabwe)", native: "isiNdebele" },
  { code: "st", name: "Sesotho",            native: "Sesotho" },
  { code: "tn", name: "Setswana",           native: "Setswana" },
  { code: "rw", name: "Kinyarwanda",        native: "Kinyarwanda" },
  { code: "lg", name: "Luganda",            native: "Luganda" },
  { code: "om", name: "Oromo",              native: "Afaan Oromoo" },
  { code: "so", name: "Somali",             native: "Soomaali" },
  { code: "wo", name: "Wolof",              native: "Wolof" },

  // Americas — indigenous
  { code: "qu", name: "Quechua",            native: "Runa Simi" },
  { code: "ay", name: "Aymara",             native: "Aymar aru" },
  { code: "gn", name: "Guarani",            native: "Avañe'ẽ" },

  // Pacific / other
  { code: "mi", name: "Maori",              native: "Te Reo Māori" },
  { code: "haw", name: "Hawaiian",          native: "ʻŌlelo Hawaiʻi" },
  { code: "sm", name: "Samoan",             native: "Gagana fa'a Sāmoa" },
  { code: "to", name: "Tongan",             native: "Lea fakatonga" },
  { code: "fj", name: "Fijian",             native: "Vosa Vakaviti" },

  // Caucasus & Central Asia
  { code: "ka", name: "Georgian",           native: "ქართული" },
  { code: "hy", name: "Armenian",           native: "Հայերեն" },
  { code: "az", name: "Azerbaijani",        native: "Azərbaycan" },
  { code: "kk", name: "Kazakh",             native: "Қазақ" },
  { code: "uz", name: "Uzbek",              native: "Oʻzbek" },
  { code: "ky", name: "Kyrgyz",             native: "Кыргызча" },
  { code: "mn", name: "Mongolian",          native: "Монгол" },
  { code: "ne", name: "Nepali",             native: "नेपाली" },
  { code: "si", name: "Sinhala",            native: "සිංහල" },
  { code: "km", name: "Khmer",              native: "ខ្មែរ" },
  { code: "lo", name: "Lao",                native: "ລາວ" },
  { code: "my", name: "Burmese",            native: "မြန်မာ" },
];
